/*------------------------------------------------------------------
[React]
-------------------------------------------------------------------*/
import React, {useEffect, useState, useContext} from "react";
/*------------------------------------------------------------------
[End React]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[API]
-------------------------------------------------------------------*/
import { API_GET_REQUEST, API_POST, API_LOGOUT, API_UPLOADS } from '../../api';
/*------------------------------------------------------------------
[End API]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[React Router]
-------------------------------------------------------------------*/
import { useHistory, NavLink } from "react-router-dom";
/*------------------------------------------------------------------
[End React Router]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Module]
-------------------------------------------------------------------*/
import {decode} from 'html-entities';
import {reactLocalStorage} from 'reactjs-localstorage';
/*------------------------------------------------------------------
[End Module]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Context]
-------------------------------------------------------------------*/
import { UserContext, NotificationContext, LocationContext } from '../../context/container'
/*------------------------------------------------------------------
[End Context]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Redux]
-------------------------------------------------------------------*/
import {useSelector, useDispatch} from 'react-redux';
import { _action_user } from '../../redux/store';
/*------------------------------------------------------------------
[End Redux]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Loading]
-------------------------------------------------------------------*/
import ReactLoading from 'react-loading';
/*------------------------------------------------------------------
[End Loading]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Functions]
-------------------------------------------------------------------*/
import { console_dev, random_character, YEAR } from "../../functions";
/*------------------------------------------------------------------
[End Functions]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Sub Screen]
-------------------------------------------------------------------*/
import Admin from "./admin";

// version
import Version from "./version.js";

// setting
import Backup from "./setting_backup";
import Source from "./setting_source";

// features
import FeatureCompressor from "./feature_compressor";
import FeatureCompressorImage from "./feature_compress_image";

// user
import UserForum from "./user_forum";
import UserGuest from "./user_guest";

// web
import WebSettings from './web/settings'
import WebThemes from './web/themes'
import WebPost from './web/post'
import WebPages from './web/pages'
import WebArchive from './web/archive'
import WebGallery from './web/gallery'
import WebTestimonial from './web/testimonial'
import WebAds from './web/ads'
import WebComments from './web/comments'
import WebImages from './web/images'
import WebMail from './web/mail'
import WebProfile from './web/profile'
import WebServices from './web/services'
import WebVideo from './web/video'
import WebUser from './web/user'
/*------------------------------------------------------------------
[End Sub Screen]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Style]
-------------------------------------------------------------------*/
import '../../style/general/node.entry.css';
import '../../style/admin/node.admin.css';
/*------------------------------------------------------------------
[End Style]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Etc]
-------------------------------------------------------------------*/
import OverlayBg from '../../assets/img/overlay_bg_form.png'
/*------------------------------------------------------------------
[End Etc]
-------------------------------------------------------------------*/

const Screen = ({loading, error, progress, setting}) => {

    /*--------------------------------------------------------------
    [History]
    ----------------------------------------------------------------*/
    const history = useHistory();
    /*--------------------------------------------------------------
    [End History]
    ----------------------------------------------------------------*/
    
    /*--------------------------------------------------------------
    [Storage]
    ----------------------------------------------------------------*/
    let STORAGE_USER_STRINGIFY = reactLocalStorage.get('@user');

	let STORAGE_USER;

	if(STORAGE_USER_STRINGIFY){
		STORAGE_USER = JSON.parse(STORAGE_USER_STRINGIFY)
	}
    /*--------------------------------------------------------------
    [End Storage]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [State]
    ----------------------------------------------------------------*/
	const [loading_stuck, set_loading_stuck] = useState(false);
    const [refresh, set_refresh] = useState(null);

    const [bamboo_user, set_bamboo_user] = useState('');
    const [bamboo_update, set_bamboo_update] = useState('');

    const [bubble_active, set_bubble_active] = useState('_bb-bubble');
    const [bubble_active_top, set_bubble_active_top] = useState('_bb-bubble-top');
    const [bubble_active_left, set_bubble_active_left] = useState('_bb-bubble-left');
    const [bubble_active_top_link, set_bubble_active_top_link] = useState('_bb-tooltip _bb-tooltip-left');
    const [bubble_active_left_link, set_bubble_active_left_link] = useState('_bb-tooltip _bb-tooltip-top');

    const [toggle, set_toggle] = useState('_toggle');
    const [sidebar, set_sidebar] = useState('_sidebar');
    const [overlay_close, set_overlay_close] = useState(false);

    const [routes, set_routes] = useState('home');

    const [element, set_element] = useState(null);
    const [sub_element, set_sub_element] = useState(null);

    const [data, set_data] = useState(null);
    const [search, set_search] = useState('');

    const [name, set_name] = useState('');
    const [password, set_password] = useState('');
    /*--------------------------------------------------------------
    [End State]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Redux]
    ----------------------------------------------------------------*/
	const dispatch = useDispatch();

    const redux_user = useSelector(state => state.user);

	const _set_redux_user = (data) => {
		dispatch(_action_user(data, 'data'))
	}
    /*--------------------------------------------------------------
    [End Redux]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Context]
    ----------------------------------------------------------------*/
    const { user, set_user } = useContext(UserContext);
    const { notification, set_notification } = useContext(NotificationContext);
    const { location, set_location } = useContext(LocationContext);
    /*--------------------------------------------------------------
    [End Context]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [API]
    ----------------------------------------------------------------*/
    const _logout = () => {

        if(loading === true){
            return
        }
        
        loading(true);

        API_LOGOUT('logout__________')
        .then((response) => {
			console.log('logout : ', response.data)
            if(response.data.result === 'success'){
                set_location('client')
                set_user('public')
                reactLocalStorage.clear();
                set_loading_stuck(false)
            }else if(response.data.error){
                if(response.data.error === 'Token Denied'){
                    set_location('client')
                    set_user('public')
                    reactLocalStorage.clear();
                    set_loading_stuck(false)
                }else{
                    error(response.data.error)
                }
            }else{
                error('Error Server')
            }
        })
        .catch((e) => {
			console.log('catch : ', e)
            error(e.message)
        }).finally(() => {
			loading(false)
		})
        
    }

    const _uploads_post = () => {

        if(loading === true){
            return 
        }

		loading(true);

		API_POST('user/post__________', {
            bamboo_user: bamboo_user,
            action: 'update',
            name: name,
            password: password
		}).then((response) => {
            console.log('response : ', JSON.stringify(response.data, undefined, 2))
            if(response.data.result == 'success'){
                reactLocalStorage.set('@user', JSON.stringify(response.data.data));
                set_user(JSON.stringify(response.data.data))
                window.location.reload();
			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
            console.log('catch : ', e)
            error(e.message)
        }).finally(() => {
            loading(false)
        })

	}
    /*--------------------------------------------------------------
    [End API]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Functions]
    ----------------------------------------------------------------*/
    const _bubble = () => {
        if(bubble_active === '_bb-bubble'){
            set_bubble_active('_bb-bubble _bb-bubble-active')
            set_bubble_active_top('_bb-bubble-top _bb-bubble-show')
            set_bubble_active_left('_bb-bubble-left _bb-bubble-show')

            set_bubble_active_top_link('_bb-tooltip _bb-tooltip-left _bb-bubble-show')
            set_bubble_active_left_link('_bb-tooltip _bb-tooltip-top _bb-bubble-show')
        }else{
            set_bubble_active('_bb-bubble')
            set_bubble_active_top('_bb-bubble-top')
            set_bubble_active_left('_bb-bubble-left')
            
            set_bubble_active_top_link('_bb-tooltip _bb-tooltip-left')
            set_bubble_active_left_link('_bb-tooltip _bb-tooltip-top')
        }
    }

    const _toggle = () => {

        if(toggle === '_sidebar'){
            set_toggle(false)
            set_sidebar('_sidebar')
            set_overlay_close(false);
        }else{
            set_toggle(true)
            set_sidebar('_sidebar _active')
            set_overlay_close(true);
        }

    }

    /*--------------------------------------------------------------
    [End Functions]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Authentication]
    ----------------------------------------------------------------*/
    if(STORAGE_USER !== undefined){
        if(STORAGE_USER[0].level === 'guest'){
            history.push('/')
            set_location('public')
        }
    }else{
        history.push('/home')
    }
    /*--------------------------------------------------------------
    [End Authentication]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Storage User]
    ----------------------------------------------------------------*/
    const _STORAGE_USER = () => {

        let storage_bamboo = STORAGE_USER[0].bamboo;
        
        if(storage_bamboo){
            set_bamboo_user(storage_bamboo)
        }

    }
    /*--------------------------------------------------------------
    [End Storage User]
    ----------------------------------------------------------------*/
    
    /*--------------------------------------------------------------
    [useEffect]
    ----------------------------------------------------------------*/
    useEffect(() => {

        _STORAGE_USER()
        
        setTimeout(() => {
            
            set_loading_stuck(true) 
            
        }, 2500);

        set_location(history.location.pathname)

    }, [refresh])
    /*--------------------------------------------------------------
    [End useEffect]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Render]
    ----------------------------------------------------------------*/
    return (
        
        <>

            {

                !loading_stuck &&
                <div className="_app_loading">
                    <div className="_position_middle">
                        <ReactLoading type={'cylon'} color={'#222'} height={50} width={50} />
                        <h2 style={{marginBottom: 6}}><span style={{color: '#118ab2'}}>e-</span>Configuration</h2>
                        <p>Saving Data . . .</p>
                    </div>				
                </div>	
            }

            <div className="_bb-background" style={{backgroundImage: `url(${API_UPLOADS + setting.background})`}}></div>
            
            <div className="_bb-position-overlay">

                {
                    overlay_close &&
                    <div onClick={() => {
                        set_sidebar('_sidebar')
                        set_overlay_close(false);
                    }} style={{position: 'fixed', top: 0, right: 0, bottom: 0, left: 0, backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 10}}>

                    </div>
                }
                <div className={sidebar}>
                    <div className="_header">
                        {
                            STORAGE_USER &&
                            <>

                                <div className="_profile">
                                    <p className="_position_middle" style={{fontSize: 60}}>{STORAGE_USER[0].username.charAt(0)}</p>
                                    <div className="_profile_upload" onClick={() => {
                                            set_bamboo_update(STORAGE_USER[0].bamboo)
                                            set_name(STORAGE_USER[0].name)
                                        }}>
                                        <ion-icon name="pencil-outline"></ion-icon>
                                    </div>
                                </div>
                                <div className="_push_t_s">
                                    <p className="_center_text" style={{maxWidth: 200, margin: 'auto'}}>{STORAGE_USER[0].name}</p>
                                </div>

                                {/* <p className="_push_t_s">{STORAGE_USER[0].username}</p> */}

                            </>
                        }
                    </div>
                    <div className="_lily_pad_v_m">
                        <div onClick={() => {
                            set_element(null)
                            set_routes('home')
                        }} className="_link_hooks _cursor_pointer">
                            <div className="_row _center_align">
                                <div className="_push_r_m">
                                    <ion-icon name="home-outline" style={{color: routes === 'home' ? '#118ab2' : 'inherit', fontSize: 20}}></ion-icon>
                                </div>
                                <div className="_column" style={{color: routes === 'home' ? '#118ab2' : 'inherit'}}>
                                    Home
                                </div>
                            </div>
                        </div>

                        {
                            user && user[0].level === 'super' &&
                                <div style={{borderWidth: 1, borderColor: '#eee', borderRightWidth: 0, borderLeftWidth: 0, borderStyle: 'solid', padding: 20, paddingTop: 10, paddingBottom: 10, marginTop: 10, marginBottom: 10}}>
                                    Features
                                </div>
                        }

                        {
                            user && user[0].level === 'super' &&
                            <div onClick={() => {
                                set_element(null)
                                set_routes('feature/compressor')
                            }} className="_link_hooks _cursor_pointer">
                                <div className="_row _center_align">
                                    <div className="_push_r_m">
                                        <ion-icon name="folder-open-outline" style={{color: routes === 'feature/compressor' ? '#118ab2' : 'inherit', fontSize: 20}}></ion-icon>
                                    </div>
                                    <div className="_column" style={{color: routes === 'feature/compressor' ? '#118ab2' : 'inherit'}}>
                                        Compressor PDF
                                    </div>
                                </div>
                            </div>
                        }

                        {
                            user && user[0].level === 'super' &&
                            <div onClick={() => {
                                set_element(null)
                                set_routes('feature/compressor/image')
                            }} className="_link_hooks _cursor_pointer">
                                <div className="_row _center_align">
                                    <div className="_push_r_m">
                                        <ion-icon name="folder-open-outline" style={{color: routes === 'feature/compressor/image' ? '#118ab2' : 'inherit', fontSize: 20}}></ion-icon>
                                    </div>
                                    <div className="_column" style={{color: routes === 'feature/compressor/image' ? '#118ab2' : 'inherit'}}>
                                        Compressor Image
                                    </div>
                                </div>
                            </div>
                        }


                        {
                            user && user[0].level === 'super' &&
                                <div style={{borderWidth: 1, borderColor: '#eee', borderRightWidth: 0, borderLeftWidth: 0, borderStyle: 'solid', padding: 20, paddingTop: 10, paddingBottom: 10, marginTop: 10, marginBottom: 10}}>
                                    Managemen User
                                </div>
                        }

                        {
                            user && user[0].level === 'super' &&
                            <>
                                <div onClick={() => {
                                    if(element === 'user'){
                                        set_element(null)
                                    }else{
                                        set_element('user')
                                    }
                                }} className="_link_hooks _cursor_pointer _relative">
                                    <div style={{position: 'absolute', left: 4, top: 13}}>
                                        {
                                            element === 'user' ?
                                                <ion-icon name="caret-down-outline" style={{fontSize: 12, color: '#999'}}></ion-icon>
                                            :
                                                <ion-icon name="caret-forward-outline" style={{fontSize: 12, color: '#999'}}></ion-icon>
                                        }
                                    </div>
                                    <div className="_row _center_align">
                                        <div className="_push_r_m">
                                            <ion-icon name="at-outline" style={{fontSize: 20}}></ion-icon>
                                        </div>
                                        <div className="_column">
                                            User Account
                                        </div>
                                    </div>
                                </div>
                                {
                                    element === 'user' &&
                                    <>
                                        <div onClick={() => set_routes('user/forum')} className="_link_hooks _cursor_pointer _relative">
                                            <div className="_row _center_align">
                                                <div className="_push_r_m">
                                                    <ion-icon name="ellipse-outline" style={{color: routes === 'user/forum' ? '#118ab2' : 'inherit', fontSize: 20}}></ion-icon>
                                                </div>
                                                <div className="_column" style={{color: routes === 'user/forum' ? '#118ab2' : 'inherit'}}>
                                                    Forum
                                                </div>
                                            </div>
                                        </div>
                                        <div onClick={() => set_routes('user/guest')} className="_link_hooks _cursor_pointer _relative">
                                            <div className="_row _center_align">
                                                <div className="_push_r_m">
                                                    <ion-icon name="ellipse-outline" style={{color: routes === 'user/guest' ? '#118ab2' : 'inherit', fontSize: 20}}></ion-icon>
                                                </div>
                                                <div className="_column" style={{color: routes === 'user/guest' ? '#118ab2' : 'inherit'}}>
                                                    Guest
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                }
                            </>
                        }

                        {
                            user && user[0].level === 'super' &&
                            <div style={{borderWidth: 1, borderColor: '#eee', borderRightWidth: 0, borderLeftWidth: 0, borderStyle: 'solid', padding: 20, paddingTop: 10, paddingBottom: 10, marginTop: 10, marginBottom: 10}}>
                                Website
                            </div>
                        }

                        {
                            user && user[0].level === 'super' &&
                            <div className="_link_hooks _cursor_pointer ___step_menu_guide">
                                <NavLink 
                                    to='/home'
                                    className="_row _center_align">
                                    <div className="_push_r_m">
                                        <ion-icon name="flash-outline" style={{color: 'inherit', fontSize: 20}}></ion-icon>
                                    </div>
                                    <div className="_column" style={{color: 'inherit'}}>
                                        Web/App
                                    </div>
                                </NavLink>
                            </div>
                        }

                        <div style={{borderWidth: 1, borderColor: '#eee', borderRightWidth: 0, borderLeftWidth: 0, borderStyle: 'solid', padding: 20, paddingTop: 10, paddingBottom: 10, marginTop: 10, marginBottom: 10}}>
                            Version
                        </div>

                        {
                            user && user[0].level === 'super' &&
                            <div onClick={() => {
                                set_element(null)
                                set_routes('version')
                            }} className="_link_hooks _cursor_pointer">
                                <div className="_row _center_align">
                                    <div className="_push_r_m">
                                        <ion-icon name="umbrella-outline" style={{color: routes === 'version' ? '#118ab2' : 'inherit', fontSize: 20}}></ion-icon>
                                    </div>
                                    <div className="_column" style={{color: routes === 'version' ? '#118ab2' : 'inherit'}}>
                                        Version
                                    </div>
                                </div>
                            </div>
                        }

                        <div style={{borderWidth: 1, borderColor: '#eee', borderRightWidth: 0, borderLeftWidth: 0, borderStyle: 'solid', padding: 20, paddingTop: 10, paddingBottom: 10, marginTop: 10, marginBottom: 10}}>
                            System
                        </div>

                        {
                            user && user[0].level === 'super' &&
                            <div onClick={() => {
                                set_element(null)
                                set_routes('source')
                            }} className="_link_hooks _cursor_pointer">
                                <div className="_row _center_align">
                                    <div className="_push_r_m">
                                        <ion-icon name="folder-open-outline" style={{color: routes === 'source' ? '#118ab2' : 'inherit', fontSize: 20}}></ion-icon>
                                    </div>
                                    <div className="_column" style={{color: routes === 'source' ? '#118ab2' : 'inherit'}}>
                                        Source
                                    </div>
                                </div>
                            </div>
                        }

                        {
                            user && user[0].level === 'super' &&
                            <div onClick={() => {
                                set_element(null)
                                set_routes('backup')
                            }} className="_link_hooks _cursor_pointer">
                                <div className="_row _center_align">
                                    <div className="_push_r_m">
                                        <ion-icon name="server-outline" style={{color: routes === 'backup' ? '#118ab2' : 'inherit', fontSize: 20}}></ion-icon>
                                    </div>
                                    <div className="_column" style={{color: routes === 'backup' ? '#118ab2' : 'inherit'}}>
                                        Backup
                                    </div>
                                </div>
                            </div>
                        }

                        <div onClick={() => _logout()} className="_link_hooks _cursor_pointer">
                            <div className="_row _center_align">
                                <div className="_push_r_m">
                                    <ion-icon name="log-out-outline" style={{color: 'inherit', fontSize: 20}}></ion-icon>
                                </div>
                                <div className="_column">
                                    Logout
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="_content">

                    <div style={{position: 'absolute', top: 18, right: 20, zIndex: 1}} className="_toggle_sidebar" onClick={() => _toggle()}>
                        <ion-icon name="menu-outline"></ion-icon>
                    </div>

                    {
                        bamboo_update.length > 0 &&
                        <>
                            <div className="_bb_modal_overlay">
                                <div className="_bb_modal_nav">
                                    <div className="_row _center_align">
                                        <div className="_column">
                                            <h3>Perbaharui Data</h3>
                                        </div>
                                        <div onClick={() =>
                                            {
                                                set_bamboo_update('')
                                                set_refresh(random_character(16))
                                                set_routes('home')
                                            } 
                                        }  className="_btn _cursor_pointer" style={{backgroundColor: '#fff', borderColor: '#eee'}}>
                                            Keluar
                                        </div>
                                    </div>
                                </div>
                                <div style={{borderWidth: 1, borderColor: '#eee', borderBottomStyle: 'solid'}} />
                                <div className="_bb_modal_body">
                                    <div className="_container">
                                        <div className="_lily_pad_h_d">
                                            <div className="_row _push_t_g _push_b_g">
                                                <div className="_column">
                                                    <div className="_heading_bold _push_b_d">
                                                        Cloud : <span className="_grey">Semua Data Akan Disimpan Pada Server Kami.</span>
                                                    </div>
                                                    <p style={{maxWidth: 300, marginBottom: 32, color: '#666'}}>Perubahan apapun akan membuat system mereset token, untuk login kembali</p>
                                                    <div className="_relative _push_b_d">
                                                        <p style={{color: '#888', fontSize: 13}}>
                                                            <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                            Name
                                                        </p>
                                                        <div className="_e_input">
                                                            <input 
                                                                placeholder=""
                                                                type={'text'} 
                                                                onChange={e => set_name(e.target.value)}
                                                                value={name}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="_relative _push_b_d">
                                                        <p style={{color: '#888', fontSize: 13}}>
                                                            <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                            Password
                                                        </p>
                                                        <div className="_e_input">
                                                            <input 
                                                                placeholder=""
                                                                type={'password'} 
                                                                onChange={e => set_password(e.target.value)}
                                                                value={password}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div onClick={() => {
                                                        _uploads_post('update')
                                                    }} className="_btn _cursor_pointer">
                                                        Simpan
                                                    </div>
                                                </div>
                                                <div className="_fmc_overlay_bg_hide">
                                                    <img style={{width: 400}} src={OverlayBg}/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    
                    }
                    
                    {
                        user ?
                            user[0].level === 'super' ?
                                // web
                                routes === 'web/settings' ?
                                    <WebSettings
                                        loading={(e) => {loading(e)}}
                                        error={(e) => error(e)}
                                        progress={(e) => progress(e)}  
                                    />
                                : routes === 'web/themes' ?
                                    <WebThemes
                                        loading={(e) => {loading(e)}}
                                        error={(e) => error(e)}
                                        progress={(e) => progress(e)}  
                                    />
                                : routes === 'web/post' ?
                                    <WebPost
                                        loading={(e) => {loading(e)}}
                                        error={(e) => error(e)}
                                        progress={(e) => progress(e)}
                                        entry={null} 
                                    />
                                : routes === 'web/pages' ?
                                    <WebPages
                                        loading={(e) => {loading(e)}}
                                        error={(e) => error(e)}
                                        progress={(e) => progress(e)} 
                                        entry={null} 
                                    />
                                : routes === 'web/archive' ?
                                    <WebArchive
                                        loading={(e) => {loading(e)}}
                                        error={(e) => error(e)}
                                        progress={(e) => progress(e)}  
                                    />
                                : routes === 'web/gallery' ?
                                    <WebGallery
                                        loading={(e) => {loading(e)}}
                                        error={(e) => error(e)}
                                        progress={(e) => progress(e)}  
                                    />
                                : routes === 'web/testimonial' ?
                                    <WebTestimonial
                                        loading={(e) => {loading(e)}}
                                        error={(e) => error(e)}
                                        progress={(e) => progress(e)}  
                                    />
                                : routes === 'web/ads' ?
                                    <WebAds
                                        loading={(e) => {loading(e)}}
                                        error={(e) => error(e)}
                                        progress={(e) => progress(e)}  
                                    />
                                : routes === 'web/comments' ?
                                    <WebComments
                                        loading={(e) => {loading(e)}}
                                        error={(e) => error(e)}
                                        progress={(e) => progress(e)} 
                                    />
                                : routes === 'web/images' ?
                                    <WebImages
                                        loading={(e) => {loading(e)}}
                                        error={(e) => error(e)}
                                        progress={(e) => progress(e)} 
                                    />
                                : routes === 'web/mail' ?
                                    <WebMail
                                        loading={(e) => {loading(e)}}
                                        error={(e) => error(e)}
                                        progress={(e) => progress(e)} 
                                    />
                                : routes === 'web/profile' ?
                                    <WebProfile
                                        loading={(e) => {loading(e)}}
                                        error={(e) => error(e)}
                                        progress={(e) => progress(e)} 
                                    />
                                : routes === 'web/services' ?
                                    <WebServices
                                        loading={(e) => {loading(e)}}
                                        error={(e) => error(e)}
                                        progress={(e) => progress(e)} 
                                    />
                                : routes === 'web/video' ?
                                    <WebVideo
                                        loading={(e) => {loading(e)}}
                                        error={(e) => error(e)}
                                        progress={(e) => progress(e)} 
                                    />
                                : routes === 'web/user' ?
                                    <WebUser
                                        loading={(e) => {loading(e)}}
                                        error={(e) => error(e)}
                                        progress={(e) => progress(e)} 
                                    />
                                : routes === 'backup' ?
                                    <Backup
                                        loading={(e) => {loading(e)}}
                                        error={(e) => error(e)} 
                                        progress={(e) => progress(e)} 
                                    />
                                : routes === 'version' ?
                                    <Version
                                        loading={(e) => {loading(e)}}
                                        error={(e) => error(e)} 
                                        progress={(e) => progress(e)} 
                                    />
                                : routes === 'source' ?
                                    <Source
                                        loading={(e) => {loading(e)}}
                                        error={(e) => error(e)} 
                                        progress={(e) => progress(e)} 
                                    />
                                : routes === 'feature/compressor' ?
                                    <FeatureCompressor
                                        loading={(e) => {loading(e)}}
                                        error={(e) => error(e)}
                                        progress={(e) => progress(e)}  
                                    />
                                : routes === 'feature/compressor/image' ?
                                    <FeatureCompressorImage
                                        loading={(e) => {loading(e)}}
                                        error={(e) => error(e)}
                                        progress={(e) => progress(e)}  
                                    />
                                : routes === 'user/forum' ?
                                    <UserForum
                                        loading={(e) => {loading(e)}}
                                        error={(e) => error(e)}
                                        progress={(e) => progress(e)}  
                                    />
                                : routes === 'user/guest' ?
                                    <UserGuest
                                        loading={(e) => {loading(e)}}
                                        error={(e) => error(e)}
                                        progress={(e) => progress(e)}  
                                    />
                                : <Admin
                                    loading={(e) => {loading(e)}}
                                    error={(e) => error(e)} 
                                    progress={(e) => progress(e)} 
                                />
                            : null
                        : null
                    }
                </div>
            </div>
            
            {
                user &&
                    user[0].level === 'super' ?

                        <div className={bubble_active} onClick={() => {
                            _bubble()
                        }}>

                            <span>
                                <ion-icon className="_bb-bubble-icon" name="apps-outline"></ion-icon> 
                            </span>

                            <div className={bubble_active_top} id="_bb-bubble-top">
                                <a onClick={() => set_routes('web/video')} className={`${bubble_active_top_link} _cursor_pointer`}>
                                    <span>Video</span>
                                    <ion-icon className="_bb-bubble-icon" name="videocam-outline"></ion-icon> 
                                </a>
                                <a onClick={() => set_routes('web/testimonial')} className={`${bubble_active_top_link} _cursor_pointer`}>
                                    <span>Testimonial</span>
                                    <ion-icon className="_bb-bubble-icon" name="balloon-outline"></ion-icon> 
                                </a>
                                <a onClick={() => set_routes('web/services')} className={`${bubble_active_top_link} _cursor_pointer`}>
                                    <span>Services</span>
                                    <ion-icon className="_bb-bubble-icon" name="extension-puzzle-outline"></ion-icon> 
                                </a>
                                <a onClick={() => set_routes('web/profile')} className={`${bubble_active_top_link} _cursor_pointer`}>
                                    <span>Profile</span>
                                    <ion-icon className="_bb-bubble-icon" name="happy-outline"></ion-icon> 
                                </a>
                                <a onClick={() => set_routes('web/ads')} className={`${bubble_active_top_link} _cursor_pointer`}>
                                    <span>Ads</span>
                                    <ion-icon className="_bb-bubble-icon" name="hand-left-outline"></ion-icon> 
                                </a>
                                <a onClick={() => set_routes('web/images')} className={`${bubble_active_top_link} _cursor_pointer`}>
                                    <span>Images</span>
                                    <ion-icon className="_bb-bubble-icon" name="images-outline"></ion-icon> 
                                </a>
                                <a onClick={() => set_routes('web/gallery')} className={`${bubble_active_top_link} _cursor_pointer`}>
                                    <span>Gallery</span>
                                    <ion-icon className="_bb-bubble-icon" name="flower-outline"></ion-icon> 
                                </a>
                                <a onClick={() => set_routes('web/comments')} className={`${bubble_active_top_link} _cursor_pointer`}>
                                    <span>Comments</span>
                                    <ion-icon className="_bb-bubble-icon" name="chatbubbles-outline"></ion-icon> 
                                </a>
                                <a onClick={() => set_routes('web/mail')} className={`${bubble_active_top_link} _cursor_pointer`}>
                                    <span>Mail</span>
                                    <ion-icon className="_bb-bubble-icon" name="mail-open-outline"></ion-icon> 
                                </a>
                                <a onClick={() => set_routes('web/user')} className={`${bubble_active_top_link} _cursor_pointer`}>
                                    <span>User</span>
                                    <ion-icon className="_bb-bubble-icon" name="person-outline"></ion-icon> 
                                </a>
                                {/* <NavLink 
                                    to={{
                                        pathname: "/home",
                                    }}
                                    className={`${bubble_active_top_link} _cursor_pointer`}
                                >
                                    <span>Web</span>
                                    <ion-icon className="_bb-bubble-icon" name="home-outline"></ion-icon>    
                                </NavLink> */}
                            </div>

                            <div className={bubble_active_left} id="_bb-bubble-left">
                                <a onClick={() => set_routes('web/settings')} className={`${bubble_active_left_link} _cursor_pointer`}>
                                    <span>Settings</span>
                                    <ion-icon className="_bb-bubble-icon" name="settings-outline"></ion-icon> 
                                </a>
                                <a onClick={() => set_routes('web/themes')} className={`${bubble_active_left_link} _cursor_pointer`}>
                                    <span>Themes</span>
                                    <ion-icon className="_bb-bubble-icon" name="leaf-outline"></ion-icon> 
                                </a>
                                <a onClick={() => set_routes('web/pages')} className={`${bubble_active_left_link} _cursor_pointer`}>
                                    <span>Pages</span>
                                    <ion-icon className="_bb-bubble-icon" name="reader-outline"></ion-icon> 
                                </a>
                                <a onClick={() => set_routes('web/post')} className={`${bubble_active_left_link} _cursor_pointer`}>
                                    <span>Post</span>
                                    <ion-icon className="_bb-bubble-icon" name="newspaper-outline"></ion-icon> 
                                </a>
                                <a onClick={() => set_routes('web/archive')} className={`${bubble_active_left_link} _cursor_pointer`}>
                                    <span>Archive</span>
                                    <ion-icon className="_bb-bubble-icon" name="albums-outline"></ion-icon> 
                                </a>
                            </div>

                        </div>

                    : null

            }

        </>
    );
    /*--------------------------------------------------------------
    [End Render]
    ----------------------------------------------------------------*/

}

export default Screen;